import { ImageAndTextCtaBtnPosition, ImageAndTextDirection } from '@nextgen-web-framework/all';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { ImageAndTextContainerProptypes } from '../../../components/ImageAndTextContainer/types/propsTypes';
import { CTABtnType } from '../../../components/ImageAndTextContainer/types/enum';
import transformTextOnly from '../text-only-transformer/text-only-transformer';

const transformImageAndText = (props: CMSTransformerDataType) => {
  const imageTextTransformedProps = Array.isArray(props?.image_and_text)
    ? props?.image_and_text[0]
    : props?.image_and_text;

  const { componentType: _, ...textOnlyConfigData } = transformTextOnly({
    text_only: {
      display_title: imageTextTransformedProps.display_title,
      description: imageTextTransformedProps.description,
      color_options: imageTextTransformedProps.color_options,
      rounded: imageTextTransformedProps.rounded,
    },
  });
  let payload: ImageAndTextContainerProptypes = {
    componentType: ComponentType.image_and_text,
    direction: imageTextTransformedProps.layout_options ?? ImageAndTextDirection.LEFT_TEXT_RIGHT_IMAGE,
    imgList: [{ alt_text: '', image: {}, viewport: [], _metadata: {} }],
    link: {},
    textOnlyConfig: textOnlyConfigData,
  };
  if (imageTextTransformedProps?.image) {
    const {
      cta,
      image: { images },
    } = imageTextTransformedProps;
    const { type, button_title, url, target, ...restProps } = cta;
    let alignment: ImageAndTextCtaBtnPosition;
    switch (type) {
      case ImageAndTextCtaBtnPosition.CENTER:
        alignment = ImageAndTextCtaBtnPosition.CENTER;
        break;
      case ImageAndTextCtaBtnPosition.RIGHT:
        alignment = ImageAndTextCtaBtnPosition.RIGHT;
        break;
      default:
        alignment = ImageAndTextCtaBtnPosition.LEFT;
        break;
    }
    payload = {
      ...payload,
      imgList: images,
      link: {
        url: url,
        target: target,
      },
    };
    payload.button =
      type === CTABtnType.NONE
        ? {}
        : {
            ...restProps,
            alignment,
            title: button_title,
          };
  }
  return payload;
};
export default transformImageAndText;
